<template>
  <el-card class="box-card" ref="card" shadow="never">
    <!--    <h3> 红人合作密度Top10</h3>-->
    <div class="d-flex-row justify-content-between">
      <span style="font-size: 18px;font-weight: bold;">红人合作密度Top10</span>
      <el-link type="primary" icon="el-icon-refresh" @click="getData">刷新</el-link>
    </div>
    <el-table class="dashboard-table"
              :data="data"
              :row-class-name="rowClassName"
              :row-style="{ border: 'none',padding:'15px 0'}"
              :cell-style="{ border: 'none'}"
              style="width: 100%">
      <el-table-column prop="index" label="排名"/>
      <el-table-column prop="artist_name" label="红人"/>
      <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`">
        <template slot-scope="scope">
          <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_count" label="订单量" align="right" sortable="custom"/>
    </el-table>
  </el-card>
</template>

<script>
import {detailArtist} from "@/api/dashboard";

export default {
  name: "detailArtist",
  props: {
    //是否限制范围
    isScope:{
      type:Boolean,
      default() {
        return false;
      }
    },
    year: [Number, String],
    brandName: {
      type: [String],
      default: ''
    },
    customerId: {
      type: [Number, String],
      default: 0
    },
    keyCustomerId: {
      type: [Number, String],
      default: 0
    },
    organizationId: {
      type: [Number, String],
      default: 'ALL'
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
  },
  data() {
    return {
      data: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.data = [];
      detailArtist({
        year: this.year,
        brand_name: this.brandName,
        organization_id: this.organizationId,
        customer_id: this.customerId,
        key_customer_id: this.keyCustomerId,
        //显示数据范围：仅当前用户
        user_id: this.user.id
      }).then(res => {
        this.data = res.model.data;
      })
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1
    },
  }
}
</script>

<style scoped>

</style>
